import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Inject,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { DocumentInlineAction } from '@textbook-api-client';
import {
  TextbookActionsHandler,
  TextbookActionsHandlerToken,
} from '../../../external/providers/textbook-actions-handler';
import { GroupInfo } from '../../models';
import { TextbookActionBase } from '../@base/textbook-action-base.model';
import { distinctUntilChanged, filter, map, Observable, of } from 'rxjs';
import { WindowOrientation } from '../@base/services';
import { isNullish } from '../../utils/is-nullish';

interface PlaceholderBounds {
  width: number;
  height: number;
}

@Component({
  selector: 'txtb-document-inline',
  templateUrl: './document-inline.component.html',
  styleUrls: ['./document-inline.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DocumentInlineComponent extends TextbookActionBase<DocumentInlineAction> implements OnInit {
  @Input() groupInfo!: GroupInfo;
  @ViewChild('wrapper') wrapper!: ElementRef;
  pagination = false;
  activeElementIndex = 0;
  placeHolderBounds: PlaceholderBounds | null | undefined = {
    width: 100,
    height: 100,
  };
  currentDeviceOS$ = this.textbookActionsHandler.currentDeviceOS$;
  currentWindowOrientation!: WindowOrientation | null;
  windowOrientation$ = this.textbookActionsHandler.windowOrientation$.pipe(
    filter(isNullish),
    distinctUntilChanged(),
    map((orientation) => this.setCurrentOrientation(orientation)),
    map(() => this.resetImageSrc())
  );

  constructor(
    @Inject(TextbookActionsHandlerToken) public textbookActionsHandler: TextbookActionsHandler
  ) {
    super();
  }

  imageSrc: string[] = [];
  imageSrc$(resourceId: string, index: number): Observable<void> {
    if (this.imageSrc[index]) {
      return of(undefined);
    }
    return this.textbookActionsHandler.getResourceBlobAsString(resourceId).pipe(
      map((src) => {
        this.imageSrc[index] = src;
      })
    );
  }

  ngOnInit(): void {
    this.pagination = this.action.meta.resourceIds.length > 1;
  }

  changeElement(e: number): void {
    const { width, height } = this.wrapper.nativeElement.getBoundingClientRect();
    this.placeHolderBounds = { width, height };
    this.activeElementIndex = e;
  }

  setCurrentOrientation(orientation: WindowOrientation): void {
    this.currentWindowOrientation = orientation;
  }

  resetImageSrc(): void {
    this.imageSrc = [];
  }
}
